import { environment } from "../../environments/environment";

export const regex = {
  phoneNumber: [
    "(",
    /[0-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  card: [
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  expiry: [/\d/, /\d/, "/", /\d/, /\d/],
  cvc: [/\d/, /\d/, /\d/]
};
// Live
export const API_URL = environment.api_url;
export const WEB_USER_URL = environment.web_user_url;

export const API_STATUS = {
  success: "success",
  error: "error",
  access_denied: "access is denied"
};
export const MESSAGE = {
  update_success: "Your profile has been updated successfully!",
  error_connect:
    "Having trouble connecting. Please check your internet connection and try again!"
};

export const PROFILE_TYPE = {
  user: 1,
  company: 2
};
export const MAP_STYLE = {
  default: {
    fillColor: "white",
    weight: 1,
    opacity: 1,
    color: "black",
    fillOpacity: 1
  },
  active: {
    fillColor: "blue",
    weight: 1,
    opacity: 1,
    color: "black",
    fillOpacity: 1
  }
};
export const PURCHASE_TYPE = {
  card: 2,
  canceled: 1,
  sec: 0
};



// WEBPACK FOOTER //
// ./src/app/constants/config.ts